import { render, staticRenderFns } from "./ForgotPage.vue?vue&type=template&id=37ccd419&scoped=true"
import script from "./ForgotPage.vue?vue&type=script&lang=js"
export * from "./ForgotPage.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/forgot.css?vue&type=style&index=0&id=37ccd419&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ccd419",
  null
  
)

export default component.exports